import { render, staticRenderFns } from "./Webinars.vue?vue&type=template&id=4056ded1"
import script from "./Webinars.vue?vue&type=script&lang=js"
export * from "./Webinars.vue?vue&type=script&lang=js"
import style0 from "./Webinars.vue?vue&type=style&index=0&id=4056ded1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports